import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puzei = () => {
    return (
        <div>
             <NavLink to='/category/Puzzels/Puzzel9'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel7'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article
    class="container">
    <h1 class="title">Find the Jar with contaminated pills</h1>
    
    <div class="text">
        <p><strong><u>Puzzle</u>: </strong>You have 5 jars of pills. Each pill weighs 10 grams, except for contaminated
            pills contained in one jar, where each pill weighs 9 grams. Given a scale, how could you tell which jar had
            the contaminated pills in just one measurement?<br/></p>
            
        <p>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;</p>
        <p><strong><u>Solution</u>:</strong> To find the contaminated Jar, follow this step-wise approach.</p>
        <ol class="containers">
            <li><strong>Step 1: </strong>Take out 1 pill from jar 1, 2 pills from jar 2, 3 pills from jar 3, 4 pills
                from jar 4 and 5 pills from jar 5.</li>
            <li><strong>Step 2:</strong> Put all these 15 pills on the scale. The correct weight is 150 (15*10). But one
                of the jars has contaminated pills. So the weight will definitely be less than 150.</li>
            <li><strong>Step 3:</strong> If the weight is 149 then jar 1 has contaminated pills because there is only
                one contaminated pill. If the weight is 148 then jar 2, if the weight is 147 then jar 3, if 146 then jar
                4, if 145 then jar 5.</li>
        </ol>
       
    </div>
</article>
        </div>
    )
}

export default Puzei
